import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import storageSession from 'redux-persist/lib/storage/session';
import { combineReducers } from "redux";
import logger from "redux-logger";
import historySlice from "./@slice/historySlice";
import bookingHallSlice from "./@slice/bookingHallSlice";
import bookingHomeApplianceSlicec from "./@slice/bookingHomeApplianceSlicec";
import recommendHallSlice from "./@slice/recommendHallSlice";
import globalSlice from "./@slice/globalSlice";
import honeymoonApplySlice from "./@slice/honeymoonApplySlice";
import recommendWGiftSlice from "./@slice/recommendWGiftSlice";
import signUpSlice from "./@slice/signUpSlice";
import userSlice, { userPersistSlice } from "./@slice/userSlice";
import realtimeBookingSlice from "./@slice/realtimeBookingSlice";
import toastSlice from "./@slice/toastSlice";
import weddingHallFilterSlice from "./@slice/weddingHallFilterSlice";
import weddingHallSlice from "./@slice/weddingHallSlice";
import weddingHallContractSlice from "./@slice/weddingHallContractSlice";
import interWindow from "./@slice/interWindowSlice";
import advertiseSlice from "./@slice/advertiseSlice";
import budgetSlice from "./@slice/budgetSlice";
import inAppGuideSlice from "./@slice/inAppGuideSlice";

const persistConfig = {
  key: "h2mwbell",
  storage,
  whitelist: ["interWindow", "userPersistData", "bookingHall"],
  transforms: [
    {
      in: (state: any) => {
        // 로컬스토리지 저장 시 hopeVisit 데이터 제외
        if (state.bookingHall && state.bookingHall.data) {
          const { hopeVisit, ...restData } = state.bookingHall.data;
          return {
            ...state,
            bookingHall: {
              ...state.bookingHall,
              data: restData,
            },
          };
        }
        return state;
      },
      out: (state: any) => {
        // 로컬스토리지 불러올 때 hopeVisit 초기값 복원 (에러 방지)
        if (state.bookingHall && state.bookingHall.data) {
          return {
            ...state,
            bookingHall: {
              ...state.bookingHall,
              data: {
                ...state.bookingHall.data,
                hopeVisit: {
                  additionalInquiry: "",
                  dates: [],
                },
              },
            },
          };
        }
        return state;
      },
    },
  ],
};
const weddingHallPersistConfig = {
  key: "weddingHall",
  storage,
  whitelist: ["layoutTooltop"], //['listLayout']
};

const budgetPersistConfig = {
  key: "budget",
  storage,
  whitelist: ["showTooltip", "type"],
};

const inAppGuidePersistConfig = {
  key: "inAppGuide",
  storage,
  whitelist: [
    "layoutTooltip",
    "sampleBudgetListTooltip",
    "compareHallTooltip",
    "cashbackNudgeSnackbar",
    "addLikeMessage",
    "recommendHallMessage",
    "reservationHallMessage",
    "firstHomeMessage",
    "firstHomeHallTooltip",
    "weddingHallOnboarding",
  ],
};
const rootReducers = combineReducers({
  history: historySlice,
  global: globalSlice,
  bookingHall: bookingHallSlice,
  bookingHomeAppliance: bookingHomeApplianceSlicec,
  recommendHall: recommendHallSlice,
  recommendWGift: recommendWGiftSlice,
  honeymoonApplyState: honeymoonApplySlice,
  signUp: signUpSlice,
  user: userSlice,
  userPersistData: userPersistSlice.reducer,
  realtimeBooking: realtimeBookingSlice,
  toast: toastSlice,
  weddingHallFilter: weddingHallFilterSlice,
  weddingHall: persistReducer(weddingHallPersistConfig, weddingHallSlice), // listLayout 로컬스토리지에 저장X (WWP-1534)
  weddingHallContract: weddingHallContractSlice,
  interWindow: interWindow,
  advertise: advertiseSlice,
  budget: persistReducer(budgetPersistConfig, budgetSlice),
  inAppGuide: persistReducer(inAppGuidePersistConfig, inAppGuideSlice),
});

const persistedReducer = persistReducer(persistConfig, rootReducers);

export const store = configureStore({
  // reducer: {
  //     history: historySlice,
  //     global: globalSlice,
  //     bookingHall: bookingHallSlice,
  //     bookingHomeAppliance: bookingHomeApplianceSlicec,
  //     recommendHall: recommendHallSlice,
  //     recommendWGift: recommendWGiftSlice,
  //     honeymoonApplyState: honeymoonApplySlice,
  //     signUp: SignUpSlice,
  //     user: UserSlice,
  //     realtimeBooking: realtimeBookingSlice,
  //     toast: toastSlice,
  // },
  reducer: persistedReducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "toast/showToast",
          "toast/showSnackbar",
        ],
        ignoredPaths: ["register", "rehydrate"],
      },
    })
      .concat
      // 추가적인 미들웨어를 여기에 추가할 수 있습니다.
      (),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
